
import React, { useState, useRef, useEffect } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
// import tmdbApi from "../../api/tmdbApi";
// import { useNavigate, Link } from "react-router-dom";
import SweetAlert from 'react-bootstrap-sweetalert';
import axios from 'axios';
import { useParams } from 'react-router-dom'
import Loader from "../../components/loader";
// import { JsonEditor } from 'jsoneditor-react';
import SessionPopup from "../SessionPopup"
import StripeModeCard from "../../components/settings/StripeModeCard";
// import 'jsoneditor-react/es/editor.min.css';
let { lambda, appname } = window.app;



const AppConfig = () => {
    let { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [jsonData, setJsonData] = useState(null);
    // const editorRef = useRef(null);

    const [serviceconfig, setServiceConfig] = useState(null);
    // const serviceRef = useRef(null);

    const [success, setSuccess] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);


    useEffect(() => {
        if (id === "appconfig") {
            fetch(lambda + '/config?appname=' + appname)
                .then(response => response?.json())

                .then(data => setJsonData(data.result[0]))
                .catch(error => console.error(error));
        } else {
            fetch(lambda + '/serviceConfig?appname=' + appname)
                .then(response => response?.json())
                .then(data => setServiceConfig(data.result.data[0]))
                .catch(error => console.error(error));
        }

    }, [id]);


    // useEffect(() => {
    //     // Update JSONEditor when state variable changes
    //     if (serviceRef.current && serviceconfig) {
    //         serviceRef.current.jsonEditor.set(serviceconfig);
    //     }
    // }, [serviceconfig]);

    // useEffect(() => {
    //     // Update JSONEditor when state variable changes
    //     if (editorRef.current && jsonData) {
    //         editorRef.current.jsonEditor.set(jsonData);
    //     }
    // }, [jsonData]);


    // const handleChange = (newData) => {
    //     setJsonData(newData);
    // };

    // const handleChangeService = (newData) => {
    //     setServiceConfig(newData);
    // };


    const handleUpdateApp = () => {
        delete jsonData['_id'];
        const token = localStorage.getItem("token")
        axios({
            method: 'PUT',
            url: lambda + '/appConfig?appname=' + appname + "&token=" + token + "&userid=" + localStorage.getItem("userId"),
            data: jsonData,
        })
            .then(function (response) {
                if (response?.result==="Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setSuccess(true)
                }

            });
    };


    const handleUpdateService = () => {
        const token = localStorage.getItem("token")
        delete serviceconfig['_id'];
        axios({
            method: 'PUT',
            url: lambda + '/serviceConfig?appname=' + appname + "&token=" + token + "&userid=" + localStorage.getItem("userId"),
            data: serviceconfig,
        })
            .then(function (response) {
                if (response?.result==="Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setSuccess(true)
                }

            });
    };

    function onConfirm() {
        setSuccess(false);
    };
    // console.log("serviceconfig", serviceconfig);



    return (
        <>
{showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                {isLoading ?
                    <Loader />
                    :
                    <div className="main-content user-management lookups">

                        <div className="page-content">
                            <div className="container-fluid">



                                <div className="row mb-4 breadcrumb">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">

                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title">{id === "appconfig" ? "APP CONFIG" : "SERIVCE CONFIG"}</h4>

                                            </div>

                                        </div>
                                    </div>
                                </div>

                                {/* Which Stripe environment this tenant is pointed at.
                                    On the APP CONFIG view because `stripeMode` lives on
                                    the appname's config document, alongside the rest of
                                    what this page edits — it is just exposed as a card
                                    with a guard rail rather than raw JSON, because
                                    getting it wrong moves real money. The switch itself
                                    is authenticated server-side; see
                                    controllers/requireAdminSession.js in the API. */}
                                {id === "appconfig" &&
                                    <div className="row table-data">
                                        <div className="col-12">
                                            <StripeModeCard onSessionExpired={() => setShowSessionPopupup(true)} />
                                        </div>
                                    </div>
                                }

                                <div className="row table-data">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">

                                                {/* {id === "appconfig" ?
                                                    <JsonEditor
                                                        ref={editorRef}
                                                        mode="tree"
                                                        // value={jsonData}
                                                        onChange={handleChange}
                                                    /> : id === "serviceconfig" ?
                                                        <JsonEditor
                                                            ref={serviceRef}
                                                            mode="tree"
                                                            // value={jsonData}
                                                            onChange={handleChangeService}
                                                        /> : null
                                                } */}



                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row">
                                    <div className="col-md-12">
                                        {id === "appconfig" ?
                                            <button className="fill-btn-style btn-block " type="submit"
                                                onClick={e => handleUpdateApp(e)}
                                            >update</button> :

                                            <button className="fill-btn-style btn-block " type="submit"
                                                onClick={e => handleUpdateService(e)}
                                            >update</button>
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>

                        <Footer />
                        <SweetAlert show={success}
                            custom
                            confirmBtnText="ok"
                            confirmBtnBsStyle="primary"
                            title={"Updated successfully"}
                            onConfirm={e => onConfirm()}
                        >
                        </SweetAlert>
                    </div>

                }
            </div>
        </>


    );
};

export default AppConfig;
